import { gsap } from "@/vendor/gsap";
import { ScrollTrigger } from "@/vendor/gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);


export const init = () => {

    const cardSections = gsap.utils.toArray(".section-card-grid, .section-speakers");

    cardSections.forEach(function(cardSection){

        const cards = cardSection.querySelectorAll(".card");

        // Set initial state for all cards
        gsap.set(cards, { autoAlpha: 0, y: '200px' });

        ScrollTrigger.batch(cards, {
            interval: 0.1,
            batchMax: 4,
            invalidateOnRefresh: true,
            start: 'top bottom',
            end: 'bottom top',
            onEnter: batch => gsap.to(batch, { autoAlpha: 1, y: 0, stagger: 0.15, overwrite: true, ease: "expo", duration: 1.25}),
        });

    });
}

export default init;
